// extracted by mini-css-extract-plugin
export default {"container":"o64om","submit-button":"Qb93p","tabs":"vB7AM","tab_content":"SYuRm"};